import { StyleSheet } from '@react-pdf/renderer';

export const pageStyle = StyleSheet.create({
    page: {
        paddingVertical: 24,
        paddingHorizontal: 32,
    },
});
